import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { useTranslation } from 'react-i18next';
import DialogCloseButton from '../Dialog/DialogCloseButton';
import _ from 'lodash';
import Dialog from '../Dialog';
const AppConfirmModal = props => {
  const { t } = useTranslation();
  const closeButtonRef = useRef();

  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (
        relatedClassName.includes('dialogComponent') &&
        !relatedClassName.includes('blueFocus')
      ) {
        return;
      } else {
        closeButtonRef.current.focus();
      }
    }
  };

  return (
    <div className="mainModal AppConfirmModal">
      <div
        className="transparentBg"
        onClick={() => props.hideAppConfirmModal()}
      ></div>
      <Dialog
        className="modalContent"
        onBlur={setFocusToCloseButton}
        escKeyFunction={props.hideAppConfirmModal}
      >
        <DialogCloseButton
          ref={closeButtonRef}
          className="closeModal"
          onClick={() => props.hideAppConfirmModal()}
          img="closeGray.svg"
        />
        <h1 className="textCenter" id="dialogTitleHeading">
          {t('Thanks')}
        </h1>
        <div className="textCenter para" role="status">
          {t(
            'We’ve sent a link to your mobile phone that will allow you to download the SingleCare app to either iPhone or Android.'
          )}
        </div>
      </Dialog>
    </div>
  );
};

AppConfirmModal.propTypes = {
  closeAppConfirmModal: PropTypes.func
};

AppConfirmModal.defaultProps = {
  closeAppConfirmModal: () => {}
};

export default AppConfirmModal;
